import React from "react";

export const Description = (props) => {
  return (
    <div className="description">
      <h2>A Brief Description</h2>
      <p>
        This project was made with a lot of love and passion for programming. I
        have used stickers to plan out each component and feature of this
        application... and it really sped up the development! As for the actual
        Stack... I used React, CSS and Firebase to make this come to life. For
        more details about this project check out the repository on my github!
      </p>
      <h3>
        <a href="https://github.com/joaobitu">See My Github</a>
      </h3>
    </div>
  );
};
